import React from 'react';
import './App.css';
import Portfolio from './components/portfolio-muhammad-irawan';

// App component
const App = () => {
  return <Portfolio />;
};

export default App;